import { leadsApi, LEAD_SOURCES } from '../api/leadsApi'
import { useCachedSourceOptions, SOURCE_CACHE_TTL_MS } from './useCachedSourceOptions'

/**
 * Source filter options for the Leads table — the complete list of distinct
 * sources in the DB (localStorage-cached via useCachedSourceOptions), so the
 * Source filter is identical on every paginated page.
 */
export function useLeadSourceFilterOptions(ttlMs: number = SOURCE_CACHE_TTL_MS) {
  return useCachedSourceOptions('crm_lead_source_options_v1', leadsApi.getSources, LEAD_SOURCES, ttlMs)
}
